import { Box, colors, Text } from 'aos-ui-universal'
import { Duration } from 'moment'
import React, { FC } from 'react'

interface LateInspectionLabelProps {
    duration: Duration
}

export const LateInspectionLabel: FC<LateInspectionLabelProps> = ({ duration }) => {
    const formattedDuration = duration.format('[-]h[H] mm[MIN]', { trim: false })
    return (
        <Box className='flex-row items-center gap-2'>
            <Box className='h-[10px] w-[10px] rounded-full bg-graphics-orange' />
            <Text size='caption' color={colors.graphics.orange}>
                {formattedDuration}
            </Text>
        </Box>
    )
}
